"use strict";
const moment = require('moment');
module.exports = {
    // returns the start and end date for the settlmenet period
    getSettlementDates: (agreement, currentDate) => {
        const dateMinusAMonth = new Date(currentDate);
        dateMinusAMonth.setMonth(dateMinusAMonth.getMonth() - 1);
        const dayOfMonth = currentDate.getDate();
        const lastMonth = dateMinusAMonth.getMonth();
        const thisMonth = currentDate.getMonth();
        const thisMonthsYear = currentDate.getFullYear();
        const yearForLastMonth = dateMinusAMonth.getFullYear();
        switch (agreement.settlementPeriod) {
            case 'weekly': {
                const mostRecentMonday = moment(currentDate)
                    .startOf('day')
                    .startOf('week') // sunday
                    .add(1, 'days');
                return {
                    startDate: mostRecentMonday
                        .clone()
                        .add(-7, 'days')
                        .format('YYYY-MM-DD'),
                    endDate: mostRecentMonday
                        .clone()
                        .add(-1, 'days')
                        .format('YYYY-MM-DD'),
                };
            }
            case 'fullAndHalfMonth':
                if (dayOfMonth < 5) {
                    return {
                        startDate: new Date(Date.UTC(yearForLastMonth, lastMonth, 16))
                            .toISOString()
                            .split('T')[0],
                        endDate: new Date(Date.UTC(thisMonthsYear, thisMonth, 0))
                            .toISOString()
                            .split('T')[0],
                    };
                }
                return {
                    startDate: new Date(Date.UTC(thisMonthsYear, thisMonth, 1))
                        .toISOString()
                        .split('T')[0],
                    endDate: new Date(Date.UTC(thisMonthsYear, thisMonth, 15))
                        .toISOString()
                        .split('T')[0],
                };
            // Looks like defaults are monthly
            case 'monthly':
            default:
                return {
                    startDate: new Date(Date.UTC(yearForLastMonth, lastMonth, 1))
                        .toISOString()
                        .split('T')[0],
                    endDate: new Date(Date.UTC(yearForLastMonth, lastMonth + 1, 0))
                        .toISOString()
                        .split('T')[0],
                };
        }
    },
};
